import { useState, useEffect } from 'react';

export const useSumUpPaymentHandler = ({succsessAction = null, errorAction = null}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [affiliateKey, setAffiliateKey] = useState(window.RUNTIME_CONFIG?.SUMUP_KEY || '');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      checkLoginStatus();
      setAffiliateKey(window.RUNTIME_CONFIG?.SUMUP_KEY || '');
    }

    window.onSumUpLoginSuccess = () => setIsLoggedIn(true);
    window.onSumUpLoginError = () => setIsLoggedIn(false);
    window.onSumUpPaymentSuccess = succsessAction;
    window.onSumUpPaymentError = errorAction;

    // Cleanup
    return () => {
      delete window.onSumUpLoginSuccess;
      delete window.onSumUpLoginError;
      delete window.onSumUpPaymentSuccess;
      delete window.onSumUpPaymentError;
    };
  }, []);

  const checkLoginStatus = () => {
    if (window.AndroidBridge) {
      setIsLoggedIn(window.AndroidBridge.isLoggedIn());
    }
  };

  const handleLogin = () => {
    if (window.AndroidBridge && affiliateKey) {
      window.AndroidBridge.loginSumUp(affiliateKey);
    }
  };

  const handlePayment = (amount) => {
    if (!window.AndroidBridge) return;

    if (!isLoggedIn) {
      handleLogin();
      return;
    }

    window.AndroidBridge.startPayment(
      amount.toFixed(2),
      null,
      null
    );
  };

  return { handlePayment };
};